import Home from './components/Home'
import Title from './components/Title'

function App() {
  return (
    <div>
      <Title />
      <Home />
    </div>
  );
}

export default App;
